"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskAssignDialog = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useUpdateTask_1 = require("../hooks/useUpdateTask");
const StyledUl = styled_components_1.default.ul `
  margin: 0;
  font-size: 12px;
  padding-left: 16px;
  li:not(:last-child) {
    margin-bottom: 4px;
  }
`;
const StyledTableContainer = (0, styled_components_1.default)(core_1.TableContainer) `
  .MuiTableHead-root .MuiTableCell-root {
    padding-top: 8px;
    padding-bottom: 8px;
    background-color: ${props => props.theme.palette.grey[100]};
  }
  .MuiTableBody-root .MuiTableCell-root {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .row-divider {
    background-color: ${props => props.theme.palette.grey[100]};
  }
  .groups {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;
const StyledForm = styled_components_1.default.form `
  width: 300px;
  padding: 8px;
  .MuiAlert-root {
    padding: 0;
  }
  .MuiAlert-icon {
    /* hide icon */
    display: none;
  }
  .MuiAlert-message {
    padding: 8px;
  }
  .menu-selection-actions {
    display: flex;
    justify-content: end;
    gap: 8px;
  }
`;
const TaskAssignDialog = props => {
    var _a;
    const { open, taskId, groupIds, multiple, parentTask, lockedUsers, initialUsers, isLegacyAssignment, title = 'Assign Task', message = 'Select a user to assign the task.', onCancel, onAssign, handleAssign } = props;
    if (multiple && !handleAssign) {
        throw new Error('TaskAssignDialog multiple select requires a custom `handleAssign` override.');
    }
    const onAssignRef = (0, react_1.useRef)(onAssign);
    onAssignRef.current = onAssign;
    const initialUsersRef = (0, react_1.useRef)(initialUsers);
    initialUsersRef.current = initialUsers;
    const [page, setPage] = (0, react_1.useState)(0);
    const [limit, setLimit] = (0, react_1.useState)(5);
    const [search, setSearch] = (0, react_1.useState)('');
    const [menuSelection, setMenuSelection] = (0, react_1.useState)();
    const [selectedGroupId, setSelectedGroupId] = (0, react_1.useState)();
    const [subTaskUsersState, setSubTaskUsers] = (0, react_1.useState)(() => initialUsers || []);
    const [debounceSearch] = (0, core_ui_1.useTimeout)();
    const { data: userList, isLoading: isFindingUsers, error: usersError, get } = (0, user_ui_1.useFindUsers)();
    const { groupList, isLoading: isFindingGroups, error: groupsError, findGroups } = (0, user_ui_1.useFindGroups)();
    // update the task when submitting
    // this is bypassed if handleAssign is passed in props
    const { data: updatedTask, isLoading: isUpdating, error: taskError, updateTask } = (0, useUpdateTask_1.useUpdateTask)(taskId);
    const subTaskUsers = (0, react_1.useMemo)(() => {
        return (lockedUsers || []).concat(subTaskUsersState);
    }, [lockedUsers, subTaskUsersState]);
    const maxColSpan = 4 + +(subTaskUsers.length > 0);
    const isLoading = isFindingUsers || isFindingGroups;
    const error = usersError || groupsError || taskError;
    const filteredUsers = (0, react_1.useMemo)(() => {
        // remove selected users since they are displayed above the user list
        return ((userList === null || userList === void 0 ? void 0 : userList.data) || []).filter(user => {
            return !subTaskUsers.some(subTask => subTask.user.id === user.id);
        });
    }, [subTaskUsers, userList]);
    const isValidSelectedUsers = (0, react_1.useMemo)(() => {
        if (!groupIds || groupIds.length === 0) {
            // skip check since there are no groupIds when adding more approvers
            return true;
        }
        return (0, workflow_core_1.checkGroupIds)({
            groupIds,
            // ignore optional subTasks
            items: subTaskUsers.filter(subTask => !subTask.isOptional),
            inGroup: (subTask, groupId) => {
                return isLegacyAssignment
                    ? (subTask.user.groups || []).some(group => group.id === groupId)
                    : !!subTask.group && subTask.group.id === groupId;
            }
        });
    }, [groupIds, isLegacyAssignment, subTaskUsers]);
    const isRequiredGroupMet = (groupId) => {
        // note that groupId may not be part of the required groups
        // and can have duplicates (multiple users per group)
        const allGroupIds = (groupIds || []).filter(id => id === groupId);
        // check if group has met total number of required groups
        const matchedSubTasks = subTaskUsers.filter(subTask => {
            var _a;
            // a subTaskUser is part of the group if it's not optional
            // and it matches either one of the user groups (old behavior)
            // or the assigned subtask group
            return (!subTask.isOptional &&
                (isLegacyAssignment
                    ? (subTask.user.groups || []).some(group => group.id === groupId)
                    : ((_a = subTask.group) === null || _a === void 0 ? void 0 : _a.id) === groupId));
        });
        return matchedSubTasks.length >= allGroupIds.length;
    };
    const toggle = (user) => {
        setSubTaskUsers(subTasks => {
            const index = subTasks.findIndex(subTask => subTask.user.id === user.id);
            if (index === -1) {
                const subTask = { user, group: undefined };
                return multiple ? subTasks.concat(subTask) : [subTask];
            }
            const copy = Array.from(subTasks);
            copy.splice(index, 1);
            return copy;
        });
    };
    const renderRow = (user, subTask) => {
        const locked = (lockedUsers || []).some(lockedUser => {
            return (lockedUser.user.id === user.id &&
                // ignore if no subTask provided
                (!subTask ||
                    // make sure subTask ids match if provided
                    ((!subTask.id || !lockedUser.id || subTask.id === lockedUser.id) &&
                        // make sure versions match if provided
                        (!subTask.version ||
                            !lockedUser.version ||
                            subTask.version === lockedUser.version) &&
                        // make sure statePaths match if provided
                        (!subTask.statePath ||
                            !lockedUser.statePath ||
                            (0, workflow_core_1.compareTaskStatus)(subTask.statePath, lockedUser.statePath)))));
        });
        const userGroups = user.groups || [];
        // if selected (has subTask), should only display the selected subTask group
        // note that selected subTask can have no group assignment
        const rowGroups = !subTask
            ? userGroups
            : subTask.group
                ? [subTask.group]
                : [];
        return (react_1.default.createElement(core_1.TableRow, { key: user.id, role: 'checkbox', color: 'primary', hover: !locked, selected: !!subTask, onClick: event => {
                if (locked) {
                    return;
                }
                else if (isLegacyAssignment ||
                    !user.groups ||
                    user.groups.length === 0) {
                    // toggle directly if legacy assignment and if user has no groups
                    return toggle(user);
                }
                // for convenience, auto select the group that the user is likely to assign
                // based on the required groupIds
                const selectedGroup = (subTask === null || subTask === void 0 ? void 0 : subTask.group) ||
                    user.groups.find(group => {
                        // find a group that is part of required groups
                        // and check if the requirement is not yet met
                        return ((groupIds === null || groupIds === void 0 ? void 0 : groupIds.includes(group.id)) && !isRequiredGroupMet(group.id));
                    });
                setMenuSelection({
                    user,
                    selected: !!subTask,
                    group: selectedGroup,
                    anchorEl: event.currentTarget,
                    anchorPosition: { top: event.clientY, left: event.clientX }
                });
            } },
            react_1.default.createElement(core_1.TableCell, { padding: 'checkbox' },
                react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', disabled: locked, checked: !!subTask, onClick: event => {
                        event.stopPropagation();
                        // toggle user directly if selected
                        if (subTask) {
                            toggle(user);
                        }
                        else {
                            setMenuSelection({
                                user,
                                selected: false,
                                anchorEl: event.currentTarget
                            });
                        }
                    } })),
            react_1.default.createElement(core_1.TableCell, null, user.firstName),
            react_1.default.createElement(core_1.TableCell, null, user.lastName),
            react_1.default.createElement(core_ui_1.WrappedTableCell, { colSpan: !subTask && subTaskUsers.length > 0 ? 2 : undefined },
                react_1.default.createElement(core_1.Tooltip
                // hide tooltip if no user groups
                , { 
                    // hide tooltip if no user groups
                    title: userGroups.length === 0 ? ('') : (react_1.default.createElement(StyledUl, null, userGroups.map(group => {
                        var _a;
                        const selected = ((_a = subTask === null || subTask === void 0 ? void 0 : subTask.group) === null || _a === void 0 ? void 0 : _a.id) === group.id;
                        return (react_1.default.createElement("li", { key: group.id },
                            selected ? react_1.default.createElement("strong", null, group.name) : group.name,
                            selected && ' - (selected)'));
                    }))) },
                    react_1.default.createElement("div", { className: 'groups' }, rowGroups.length === 0 ? (react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary' }, subTask ? 'No Team' : '-')) : (rowGroups.map((group, index, array) => {
                        var _a;
                        return (react_1.default.createElement(react_1.Fragment, { key: group.id },
                            ((_a = subTask === null || subTask === void 0 ? void 0 : subTask.group) === null || _a === void 0 ? void 0 : _a.id) === group.id ? (react_1.default.createElement("strong", null, group.name)) : (group.name),
                            index < array.length - 1 && ', '));
                    }))))),
            subTask && (react_1.default.createElement(core_1.TableCell, null,
                react_1.default.createElement(core_1.Checkbox, { size: 'small', color: 'primary', disabled: locked, checked: subTask.isOptional || false, onClick: event => event.stopPropagation(), onChange: (_, checked) => {
                        setSubTaskUsers(subTasks => {
                            const index = subTasks.findIndex(subTask => subTask.user.id === user.id);
                            if (index > -1) {
                                subTasks = Array.from(subTasks);
                                subTasks[index] = Object.assign(Object.assign({}, subTasks[index]), { isOptional: checked });
                            }
                            return subTasks;
                        });
                    } })))));
    };
    // set initial users on open only
    (0, react_1.useEffect)(() => {
        if (open && initialUsersRef.current && initialUsersRef.current.length > 0) {
            setSubTaskUsers(initialUsersRef.current);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        findGroups({ ids: groupIds || [] });
    }, [findGroups, groupIds]);
    (0, react_1.useEffect)(() => {
        const params = { page, limit, search };
        if (selectedGroupId) {
            params.groupIds = [selectedGroupId];
        }
        get(params);
    }, [limit, page, search, selectedGroupId, get]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedTask) {
            (_a = onAssignRef.current) === null || _a === void 0 ? void 0 : _a.call(onAssignRef, updatedTask);
        }
    }, [updatedTask]);
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, title),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, null, message),
            react_1.default.createElement(core_1.Box, { mt: 1, mb: 2 },
                react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, type: 'text', name: 'name', variant: 'outlined', autoComplete: 'off', label: 'Employee Name', onChange: event => {
                        debounceSearch(() => {
                            // multiple set state calls inside async or setTimeout
                            // can cause multiple re-renders (calls the fetch request twice)
                            // NOTE: taken from https://stackoverflow.com/a/65427240/7013346
                            react_dom_1.default.unstable_batchedUpdates(() => {
                                setPage(0);
                                setSearch(event.target.value);
                            });
                        }, 300);
                    } }),
                react_1.default.createElement(core_1.Box, { mt: 1, mb: 2 },
                    react_1.default.createElement(user_ui_1.GroupPicker, { value: selectedGroupId, textFieldProps: { size: 'medium' }, onChange: group => setSelectedGroupId(group === null || group === void 0 ? void 0 : group.id) })),
                groupIds && groupIds.length > 0 && (react_1.default.createElement(core_1.Box, { mt: 1 },
                    react_1.default.createElement(lab_1.Alert, { color: isValidSelectedUsers ? 'success' : 'warning' },
                        "Assign ",
                        groupIds.length,
                        " or more Users from:",
                        ' ', (_a = groupList === null || groupList === void 0 ? void 0 : groupList.data) === null || _a === void 0 ? void 0 :
                        _a.map((group, index, arr) => (react_1.default.createElement(react_1.Fragment, { key: group.id },
                            isRequiredGroupMet(group.id) && (react_1.default.createElement(icons_1.Check, { fontSize: 'small', style: {
                                    marginTop: -4,
                                    marginRight: 2,
                                    verticalAlign: 'middle'
                                } })),
                            react_1.default.createElement("strong", null,
                                groupIds.filter(id => id === group.id).length,
                                ' ',
                                group.name),
                            index < arr.length - 1 && ', '))))))),
            react_1.default.createElement(core_1.Card, null,
                react_1.default.createElement(StyledTableContainer, null,
                    react_1.default.createElement(core_1.Table, null,
                        react_1.default.createElement(core_1.TableHead, null,
                            react_1.default.createElement(core_1.TableRow, null,
                                react_1.default.createElement(core_1.TableCell, null),
                                react_1.default.createElement(core_1.TableCell, null, "First Name"),
                                react_1.default.createElement(core_1.TableCell, null, "Last Name"),
                                react_1.default.createElement(core_1.TableCell, null, "Team"),
                                subTaskUsers.length > 0 && react_1.default.createElement(core_1.TableCell, null, "Optional"))),
                        react_1.default.createElement(core_1.TableBody, null,
                            subTaskUsers.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(core_1.TableRow, { className: 'row-divider' },
                                    react_1.default.createElement(core_1.TableCell, { colSpan: maxColSpan },
                                        react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Selected Users"))),
                                subTaskUsers.map(subTask => {
                                    return renderRow(subTask.user, subTask);
                                }),
                                react_1.default.createElement(core_1.TableRow, { className: 'row-divider' },
                                    react_1.default.createElement(core_1.TableCell, { colSpan: maxColSpan },
                                        react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Available Users"))))),
                            isLoading && (react_1.default.createElement(core_1.TableRow, null,
                                react_1.default.createElement(core_1.TableCell, { colSpan: maxColSpan, padding: 'none' },
                                    react_1.default.createElement(core_1.LinearProgress, null)))),
                            error && (react_1.default.createElement(core_1.TableRow, null,
                                react_1.default.createElement(core_1.TableCell, { colSpan: maxColSpan, padding: 'none' },
                                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)))),
                            filteredUsers.map(user => renderRow(user))))),
                react_1.default.createElement(core_1.TablePagination, { component: 'div', page: page, rowsPerPage: limit, count: (userList === null || userList === void 0 ? void 0 : userList.total) || 0, rowsPerPageOptions: [5, 10, 25], onPageChange: (_, page) => setPage(page), onRowsPerPageChange: event => {
                        setLimit(+event.target.value);
                        setPage(0);
                    } }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: isUpdating ||
                    !isValidSelectedUsers ||
                    subTaskUsersState.length === 0, endIcon: isUpdating && react_1.default.createElement(core_1.CircularProgress, { size: 20 }), onClick: () => {
                    // use subTaskUsersState and skip lockedUsers
                    // also make sure isOptional is properly (no undefined)
                    const users = subTaskUsersState.map((subTask) => {
                        var _a;
                        return {
                            id: subTask.user.id,
                            groupId: ((_a = subTask.group) === null || _a === void 0 ? void 0 : _a.id) || null,
                            isOptional: !!subTask.isOptional
                        };
                    });
                    // only use handleAssign() for multiple selects
                    if (multiple && handleAssign) {
                        handleAssign(users);
                    }
                    else {
                        // assume user has value (already checked in disabled prop)
                        const user = users[0];
                        updateTask({
                            userId: user.id,
                            groupId: user.groupId,
                            isOptional: user.isOptional,
                            statePath: parentTask === null || parentTask === void 0 ? void 0 : parentTask.status
                        });
                    }
                } }, "Assign")),
        react_1.default.createElement(core_1.Popover, { open: !!menuSelection, id: 'task-assign-dialog-menu', anchorEl: menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.anchorEl, anchorPosition: menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.anchorPosition, anchorReference: (menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.anchorPosition) ? 'anchorPosition' : undefined, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setMenuSelection(undefined) },
            react_1.default.createElement(StyledForm, { onSubmit: event => {
                    event.preventDefault();
                    if (!menuSelection) {
                        return;
                    }
                    setSubTaskUsers(subTasks => {
                        const index = subTasks.findIndex(subTask => subTask.user.id === menuSelection.user.id);
                        const item = Object.assign(Object.assign({}, subTasks[index]), { user: menuSelection.user, group: menuSelection.group });
                        if (index === -1) {
                            return multiple ? subTasks.concat(item) : [item];
                        }
                        const copy = Array.from(subTasks);
                        copy[index] = item;
                        return copy;
                    });
                    setMenuSelection(undefined);
                } },
                react_1.default.createElement(core_1.Box, { mb: 1 },
                    react_1.default.createElement(core_1.Typography, { variant: 'caption' }, "Select the Team to sign off as")),
                react_1.default.createElement(core_1.Box, { mb: 1 },
                    react_1.default.createElement(lab_1.Autocomplete, { size: 'small', value: (menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.group) || null, options: (menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.user.groups) || [], getOptionLabel: option => option.name, getOptionSelected: (option, value) => option.id === value.id, onChange: (_, value) => {
                            setMenuSelection(selection => {
                                return (selection && Object.assign(Object.assign({}, selection), { group: value || undefined }));
                            });
                        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, autoFocus: true, variant: 'outlined', placeholder: 'Team' }))) })),
                menuSelection && (react_1.default.createElement(core_1.Box, { mb: 1 },
                    react_1.default.createElement(lab_1.Alert, { severity: menuSelection.group ? 'success' : 'info' },
                        react_1.default.createElement(core_1.Typography, { variant: 'caption' },
                            "User",
                            ' ',
                            react_1.default.createElement("strong", null,
                                menuSelection.user.firstName,
                                " ",
                                menuSelection.user.lastName),
                            ' ',
                            "will sign off",
                            ' ',
                            menuSelection.group ? (react_1.default.createElement(react_1.default.Fragment, null,
                                "representing the team",
                                ' ',
                                react_1.default.createElement("strong", null, menuSelection.group.name))) : ('with no team assignment'),
                            ".")))),
                react_1.default.createElement(core_1.Box, { className: 'menu-selection-actions' },
                    (menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.selected) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', onClick: () => {
                                setSubTaskUsers(subTasks => {
                                    const index = subTasks.findIndex(subTask => subTask.user.id === menuSelection.user.id);
                                    if (index > -1) {
                                        subTasks = Array.from(subTasks);
                                        subTasks.splice(index, 1);
                                    }
                                    return subTasks;
                                });
                                setMenuSelection(undefined);
                            } }, "Remove"),
                        react_1.default.createElement("div", { style: { flex: 1 } }))),
                    react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', onClick: () => setMenuSelection(undefined) }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { size: 'small', type: 'submit', color: 'primary', variant: 'outlined' }, (menuSelection === null || menuSelection === void 0 ? void 0 : menuSelection.selected) ? 'Update' : 'Assign User'))))));
};
exports.TaskAssignDialog = TaskAssignDialog;
exports.default = exports.TaskAssignDialog;
//# sourceMappingURL=TaskAssignDialog.js.map